import moment from "moment"
import * as yup from "yup"

export interface IError {
  message: IErrorMessage
}

export interface IErrorMessage {
  id: string
  values: object
}

yup.setLocale({
  mixed: {
    required: () => ({ id: "required_field" }),
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    notType: ({ type }) => ({ id: `type_error.${type}` }),
  },
  string: {
    email: () => ({ id: "email" }),
  },
  number: {
    moreThan: ({ more }) => ({ id: `number.morethan`, values: { value: more } }),
    lessThan: ({ less }) => ({ id: `number.lessthan`, values: { value: less } }),
  },
  date: {
    min: ({ min }) => ({ id: `date.min`, values: { date: moment(min).format("DD/MM/YYYY") } }),
    max: ({ max }) => ({ id: "date.max", values: { date: moment(max).format("DD/MM/YYYY") } }),
  },
})
